/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 4/17/2023
 */
import React from "react";
import {Route, Routes} from "react-router-dom";
import {
    AdvancedSettings,
    ControlPanel,
    CredentialManager,
    Layout,
    MyProfile,
    UserAccounts,
    UserPermissions,
} from "../../../modules";
import Dashboard from "../pages/dashboard/Dashboard";
import Organization from "../pages/organization/Organization"
import Groups from "../pages/groups/Groups"
import Terminals from "../pages/terminals/Terminals"
import AppManagement from "../pages/application/AppManagement"
import Reports from "../pages/reports/Reports";

const appName = process.env.REACT_APP_NAME;

/*This component act as the Layout or container that contains the Toms app pages and components. The components goes inside the Base Layout.*/

const Container = () => {
    return (
        <div>
            <Layout>
                <Routes>
                    <Route path="/dashboard" element={<Dashboard/>}/>
                    <Route path="/controlPanel" element={<ControlPanel/>}/>
                    <Route path="/userAccounts" element={<UserAccounts/>}/>
                    <Route path="/userPermissions" element={<UserPermissions/>}/>
                    <Route path="/advancedSettings" element={<AdvancedSettings/>}/>
                    <Route path="/credentialManager" element={<CredentialManager/>}/>
                    <Route path="/myProfile" element={<MyProfile/>}/>
                    <Route path="/organization" element={<Organization/>}/>
                    <Route path="/groups" element={<Groups/>}/>
                    <Route path="/terminals" element={<Terminals/>}/>
                    <Route path="/reports" element={<Reports/>}/>
                    <Route path="/appManagement" element={<AppManagement/>}/>
                </Routes>
            </Layout>
        </div>
    )
};
export default Container;
